export enum adminCompanyDetailTypes {
    FETCH_ADMIN_COMPANY_DETAIL_REQUEST = "FETCH_ADMIN_COMPANY_DETAIL_REQUEST",
    FETCH_ADMIN_COMPANY_DETAIL_SUCCESS = "FETCH_ADMIN_COMPANY_DETAIL_SUCCESS",
    FETCH_ADMIN_COMPANY_DETAIL_FAILURE = "FETCH_ADMIN_COMPANY_DETAIL_FAILURE",
  }